import { useTranslation } from "react-i18next";
import { Car, Pencil, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export function VehiclesList({ vehicles, onEdit, onRemove }) {
  const { t } = useTranslation();
  if (vehicles.length === 0) {
    return <div className="text-center py-16 bg-white rounded-2xl border border-border"><Car className="w-12 h-12 text-border mx-auto mb-3" /><p className="text-muted2 font-body">{t("dash.noVehicles")}</p></div>;
  }
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {vehicles.map((v) => (
        <div key={v.id} data-testid={`fleet-vehicle-${v.id}`} className="bg-white rounded-2xl shadow-card border border-border p-4 flex gap-4">
          <img src={v.photos?.[0]} alt="" className="w-28 h-24 object-cover rounded-xl bg-sand" />
          <div className="flex-1">
            <div className="flex items-start justify-between">
              <div>
                <h3 className="font-heading font-bold text-ink">{v.brand} {v.model}</h3>
                <p className="text-xs text-muted2 font-mono">{v.plate}</p>
              </div>
              <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${v.status === "active" ? "bg-emeraude/15 text-emeraude-dark" : "bg-red-100 text-red-600"}`}>{v.status === "active" ? t("dash.active") : t("dash.suspended")}</span>
            </div>
            <p className="text-canard-dark font-heading font-bold mt-1">{v.price_per_day} €/j</p>
            <div className="flex gap-2 mt-2">
              <Button size="sm" variant="outline" data-testid={`edit-vehicle-${v.id}`} onClick={() => onEdit(v)} className="rounded-full h-8"><Pencil className="w-3.5 h-3.5" /></Button>
              <Button size="sm" variant="outline" data-testid={`delete-vehicle-${v.id}`} onClick={() => onRemove(v.id)} className="rounded-full h-8 text-destructive border-destructive/30"><Trash2 className="w-3.5 h-3.5" /></Button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
